export const licenseKey = import.meta.env.NG_APP_PUBLIC_DEVEXPRESS_LICENSE_KEY;